<template lang="pug">
.form-group.dawn-checkbox-group
  label.control-label(v-if='fieldLabel', :class='{ error }') {{ fieldLabel }}
    em.optional(v-if='!required && !hideOptional') &nbsp;- optional
  ed-input-tooltip(v-if='helptipBody && error'
                  :class='{ "error-message": error }'
                  :helptipHeader='helptipHeader'
                  :errorTip='error'
                  :helptipBody='helptipBody'
  )
  checkbox(v-for='(option, index) in options || filteredOptions'
          :class='{ "checked": option.status }'
          v-show='!option.hide'
          v-model='localValue'
          :name='name'
          :key='index'
          :option-index='index'
          :option-label='option.label || option'
          :option-status='checked(option)'
          @change-status='changeStatus(option, $event)'
          :disabled='disabled || option.isDisabled'
          :removeOnly='removeOnly'
          :error='error'
          :icon='option.icon'
          :iconColor='option.iconColor'
          )
  slot(name='additionalText')
</template>

<script>
import Checkbox from './checkbox.vue'

export default {
  name: 'ed-checkbox',

  props: {
    value: null,
    defaultValue: Boolean,
    options: Array,
    fieldLabel: String,
    hideOptional: Boolean,
    name: String,
    disabled: Boolean,
    removeOnly: Boolean,
    error: Boolean,
    helptipHeader: String,
    helptipBody: String,
    required: {
      type: Boolean,
      default: false
    }
  },

  components: {
    'checkbox': Checkbox
  },

  computed: {
    filteredOptions() {
      return this.value
    }
  },

  data() {
    return {
      localValue: null,
      localOptions: null
    }
  },

  created() {
    this.listModel = this.value && this.value.constructor === Array
    this.initList()
  },

  methods: {
    initList() {
      if (typeof this.options === 'undefined') {
        this.modelBased = true
        this.localOptions = this.value
      }
    },
    changeStatus(option, value) {
      option.status = value
      let _value = value

      if (this.listModel && !this.modelBased) {
        let copy = this.value.slice()
        let _option = option.key || option

        value
          ? copy.indexOf(_option) >= 0 || copy.push(_option)
          : copy.splice(copy.indexOf(_option), 1)
        _value = copy
      }

      this.$emit('select')

      if (this.modelBased) {
        this.$emit('input', this.localOptions)
      } else {
        this.$emit('input', _value)
      }

      this.$emit('click', option)
    },
    checked(option) {
      if (this.listModel && !this.modelBased) {
        return this.value.indexOf(option.key || option) >= 0
      }

      return typeof option.status === 'undefined' ? this.defaultValue : option.status
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

// Checkbox
.form-group {
  em.optional {
    @include optional-label;
  }

  &.text-left {
    .form-check-label .text {
      float: left;
      margin-right: 1em;
    }
  }
  
  &.line-break {
    .form-check-label .text {
      white-space: pre;
      display: inline-block;
      vertical-align: top;
      max-width: 90%;
    }
  }
}

.form-group.option.inline {
  display: inline;
  margin: 0;
}

.form-group.dawn-checkbox-group {
  &.error {
    position: relative;
  }
  & {
    .dawn-input-tooltip.error-message {
      min-width: 350px;
      top: -1.1em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/core/components/edCheckbox/index.vue